module.exports = __webpack_public_path__ + "static/media/24.55d67e3c.jpg";